import styled from 'styled-components';
import AppleSVG from 'assets/images/apple.svg';
import AndroidSVG from 'assets/images/android.svg';
import Button from 'components/ui/Button';

export const ImgContainer = styled.div`
  text-align: center;
`;

export const ButtonContainer = styled.div`
  text-align: center;
`;
export const CentredLabelContainer = styled.div`
  text-align: center;
`;

export const CentredLabelContainerBold = styled.div`
  font-weight: bold;
  text-align: center;
`;

export const NavigationButton = styled(Button)`
  display: inline-block;
  width: 128px;
  margin-left: auto;
  margin-right: auto;
`;

export const AppleImg = styled.img`
  cursor: pointer;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
  width: 128px;
  height: 128px;
`;

export const AndroidImg = styled.img`
  cursor: pointer;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
  width: 128px;
  height: 128px;
`;

AppleImg.defaultProps = {
  src: AppleSVG
};

AndroidImg.defaultProps = {
  src: AndroidSVG
};
